import { colors } from "./theme";

// 3D-only tokens for the world-space diegetic panel system
// (src/ui/panel3d/). theme.ts stays DOM-only (React.CSSProperties) — see
// CLAUDE.md, which names it the token source; this file sits beside it
// instead of overloading it with meters/renderOrder.
//
// `colors.washi` (#ECE3D0, from theme.ts) is INK — the pale paper color used
// for BODY TEXT in 9+ places across the DOM and the legacy world-space
// screens. SURFACE.washi* below is the opposite: a dim, back-lit paper
// SURFACE a panel is built from (the mockup's washiFill gradient). Never use
// one where the other belongs — INK.paper (= colors.washi) is for text sitting
// on a panel; SURFACE.washi* is for the panel itself.
export const SURFACE = {
  washiTop: "#5A4A30",
  washiMid: "#3F3320",
  washiBottom: "#2A2114",
  latticeWood: "#1C140C",
  frameWood: "#3A2A1A",
  fibre: "rgba(255,230,190,0.035)",
  andon: colors.amber,
  chipFill: "#241A10",
  chipBorder: "#5A4326",
  chipFillSelected: "#3A2A10",
  chipBorderSelected: "#7A5A1E",
} as const;

export const INK = {
  title: colors.gold,
  accent: colors.amber,
  body: colors.steel,
  paper: colors.washi,
  seiji: "#F0DCAE",
  warn: "#E8927F",
  dim: colors.border,
} as const;

// renderOrder bands. Painéis diegéticos (objetos do dōjō — a katana deve
// ocluí-los) usam depthTest:true nas bandas RO.panel*; instrumentos/overlays
// de sistema (que nunca devem ser ocluídos, ex. PauseScreen sobre blocos
// congelados) usam depthTest:false nas bandas RO.overlay*. HUD (1000-1003) e
// ResultScreen (2000-2001, depthTest ligado) já seguem essa convenção —
// bandas legadas, não tocar.
export const RO = {
  hudBacking: 1000,
  hudChrome: 1001,
  hudText: 1002,
  hudAccent: 1003,
  panelFrame: 2000,
  panelSurface: 2005,
  panelRule: 2010,
  panelImage: 2020,
  panelEnso: 2030,
  panelChip: 2035,
  panelText: 2040,
  overlayBacking: 2200,
  overlayText: 2240,
} as const;

// Physical z-offsets (meters) layered on top of RO bands — keeps ordering
// correct even when depthTest is on (RO.panel* default), since renderOrder
// alone doesn't guarantee draw order against real depth-tested geometry.
export const Z = {
  rule: 0.004,
  image: 0.006,
  enso: 0.008,
  chip: 0.01,
  text: 0.012,
} as const;
